import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@jana-technology/platform-ui";

import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { useRiskManagementFiltersContext } from "contexts/filters/risk-management-filters";

import SidebarComponentHeading from "./ComponentHeading";
import SidebarSpacer from "./Spacer";

export const RiskMitigationSelect = () => {
  const { riskMitigationQueryResult } = useGlobalFiltersContext();
  const { savedRiskMitigationId, setSavedRiskMitigationId } =
    useRiskManagementFiltersContext();

  const { riskMitigations } = riskMitigationQueryResult.data ?? {};

  return (
    <SidebarSpacer>
      <SidebarComponentHeading>Mitigation Scenario:</SidebarComponentHeading>
      {riskMitigations && (
        <Select
          value={String(savedRiskMitigationId)}
          onValueChange={(value) => {
            const nextMitigationId = Number(value);
            setSavedRiskMitigationId(nextMitigationId);
          }}
        >
          <SelectTrigger className="w-full" id="risk-mitigation-select">
            <SelectValue placeholder="Select one" />
          </SelectTrigger>
          <SelectContent>
            {riskMitigations.filter(Boolean).map((mitigation) => (
              <SelectItem key={mitigation?.id} value={String(mitigation?.id)}>
                {mitigation?.value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </SidebarSpacer>
  );
};

export default RiskMitigationSelect;
